import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../../context/useAuth";
import { RouteSkeleton } from "../../shared/components/Skeleton";

export const ProtectedRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { isAuthenticated, isLoading } = useAuth();

  if (isLoading) {
    return <RouteSkeleton />;
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace state={{ from: "/app" }} />;
  }

  return <>{children}</>;
};
